import React, { Component } from "react";
import _ from "underscore";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { getRequest, postRequest } from "../../utils/httpRequest";
import { formErrors } from "../../utils/formErrors";
import { t } from "../../utils/i18n";
import DefaultForm from "./DefaultForm";
import SignupForm from "./SignupForm";
import TableBody from "./TableBody";
import premiums from "./premiums.json";
import ReactTooltip from 'react-tooltip';
import { isPossiblePhoneNumber } from 'react-phone-number-input'

import "./index.scss";

class InsuranceCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateOfBirth: props.params?.age ? this.setAge(props.params.age) : null,
      selectedGender: props.params?.gender || "male",
      selectedPremium: props.params?.premium || 2000,
      nonTerminalIllness: true,
      validationErrors: {},
      email: "",
      phoneNumber: "",
      firstName: "",
      lastName: "",
      selectedCountry: { label: "United States", value: "US" },
      countries: props.params.countries,
      mode: "default",
      creating: false,
      policies: []
    };
  }

  componentDidMount() {}

  setAge = age => {
    const date = moment()
      .subtract(age, "years")
      .format("YYYY-MM-DD");

    return new Date(date);
  };

  onChangeDateOfBirth = dateOfBirth => {
    // console.log(dateOfBirth)
    this.setState({ dateOfBirth }, () => this.validateDateOfBirth());
  };

  validateDateOfBirth = () => {
    const { dateOfBirth, validationErrors } = this.state;

    if (dateOfBirth) {
      validationErrors.dateOfBirthError = "";
      this.setState({ validationErrors });
    } else {
      validationErrors.dateOfBirthError = t("referrals.insurance_calc.fill_field");
      this.setState({ validationErrors });
    }
  };

  handleChange = (e, key) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({ [key]: value });
  };

  handleCountryChange = selectedCountry => {
    this.setState({ selectedCountry });
  };

  validatePhoneNumber = phoneNumber => {
    // const regex = /[0-9]{3}-[0-9]{3}-[0-9]{4}/g;
    // return phoneNumber.match(regex);
    return isPossiblePhoneNumber(phoneNumber);
  };

  validateFormFields = () => {
    const {
      dateOfBirth,
      email,
      mode,
      firstName,
      lastName,
      phoneNumber
    } = this.state;

    let validationErrors = {};

    if (mode === "default" && !dateOfBirth) {
      validationErrors.dateOfBirthError = t("referrals.insurance_calc.fill_dob");
    }

    if (mode === "sign-up") {
      if (!email) {
        validationErrors.emailError = t("referrals.insurance_calc.fill_email");
      }

      if (!phoneNumber) {
        validationErrors.phoneNumberError = t("referrals.insurance_calc.fill_phone");
      } else if (!this.validatePhoneNumber(phoneNumber)) {
        validationErrors.phoneNumberError =
         t("referrals.insurance_calc.invalid_phone");
      }

      if (!firstName) {
        validationErrors.firstNameError =
          t("referrals.insurance_calc.fill_first");
      }

      if (!lastName) {
        validationErrors.lastNameError =
          t("referrals.insurance_calc.fill_last");
      }
    }

    return validationErrors;
  };

  back = e => {
    e.preventDefault();

    this.setState({ mode: "default" });
  };

  preview = e => {
    e.preventDefault();

    this.setState({ mode: "sign-up" });
  };

  submit = e => {
    e.preventDefault();

    const { dateOfBirth, selectedPremium, selectedGender } = this.state;

    const validationErrors = this.validateFormFields();

    if (!_.isEmpty(validationErrors)) {
      this.setState({ validationErrors });

      return;
    }

    this.setState({ submitting: true, error: "", validationErrors: {} });

    getRequest(
      `/insurance_policies?date_of_birth=${dateOfBirth}&gender=${selectedGender}&premium=${selectedPremium}`
    )
      .then(response => {
        this.setState({
          policies: response,
          mode: "preview",
          submitting: false
        });
      })
      .catch(error => {
        this.setState({ submitting: false });
        console.log(error);
      });

      let card_container = document.querySelector('.insurance-calculator-card')

      // scroll down
      window.scrollTo({
        top: card_container.offsetHeight*1.5,
        left: 100,
        behavior: 'smooth'
      });
  };

  createInsuranceLead = e => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      selectedGender,
      selectedPremium,
      dateOfBirth,
      selectedCountry
    } = this.state;
    e.preventDefault();

    const validationErrors = this.validateFormFields();

    if (!_.isEmpty(validationErrors)) {
      this.setState({ validationErrors });

      return;
    }

    this.setState({ creating: true, error: "", validationErrors: {} });

    const crsfToken = $('meta[name="csrf-token"]').attr("content");

    const data = {
      insurance_lead: {
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phoneNumber,
        premium: selectedPremium,
        gender: selectedGender,
        date_of_birth: dateOfBirth,
        country: selectedCountry.label
      }
    };

    postRequest("/insurance_leads", data, {
      "X-CSRF-Token": crsfToken
    })
      .then(response => {
        this.setState({ creating: false, mode: "lead-created" });
      })
      .catch(error => {
        const errors = formErrors(error.data.errors);

        const formattedErrors = this.formattedErrors(errors);

        this.setState({
          validationErrors: formattedErrors,
          creating: false
        });
      });
  };

  formattedErrors = errors => {
    const { validationErrors } = this.state;

    const firstNameError = errors["first_name"];
    const lastNameError = errors["last_name"];
    const emailError = errors["email"];
    const phoneNumberError = errors["phone_number"];
    const dateOfBirthError = errors["date_of_birth"];

    validationErrors.firstNameError = firstNameError;
    validationErrors.lastNameError = lastNameError;
    validationErrors.emailError = emailError;
    validationErrors.phoneNumberError = phoneNumberError;
    validationErrors.dateOfBirthError = dateOfBirthError;

    return validationErrors;
  };

  getSelectedPremium = () => {
    const { selectedPremium } = this.state;

    return _.find(premiums, function(premium) {
      return premium.value === Number(selectedPremium);
    });
  };

  scrollToAction = e => {
    e.preventDefault();

    // $("html, body").animate(
    //   {
    //     scrollTop: $("#call-to-action").offset().top - 300
    //   },
    //   1000
    // );
    this.setState({ mode: "sign-up" });
    window.scrollTo(0, 0);
  };

  render() {
    const {
      dateOfBirth,
      selectedGender,
      selectedPremium,
      nonTerminalIllness,
      validationErrors,
      mode,
      email,
      phoneNumber,
      firstName,
      lastName,
      selectedCountry,
      countries,
      policies,
      submitting,
      creating
    } = this.state;

    const defaultMode = mode === "default" || mode === "preview";

    return (
      <div className="container-fluid insurance-calculator">
        <div className="insurance-calculator-card col-12 col-md-8 mr-auto ml-auto">
          {/* <h3>Calculator</h3> */}
          <div className="card">
            <div className="card-header">
              <header className="text-center">
                <div className="profile">
                  <img src="https://media.bananacrystal.com/wp-content/uploads/2020/12/30060859/cropped-bananacrystal-logo-400x100-1-1.png" />
                </div>
              </header>
            </div>
            <div className="card-body">
              {defaultMode && (
                <DefaultForm
                  selectedGender={selectedGender}
                  dateOfBirth={dateOfBirth}
                  selectedPremium={selectedPremium}
                  mode={mode}
                  submitting={submitting}
                  nonTerminalIllness={nonTerminalIllness}
                  validationErrors={validationErrors}
                  submit={this.submit}
                  preview={this.preview}
                  handleChange={this.handleChange}
                  onChangeDateOfBirth={this.onChangeDateOfBirth}
                />
              )}
              {mode === "sign-up" && (
                <SignupForm
                  selectedGender={selectedGender}
                  dateOfBirth={dateOfBirth}
                  firstName={firstName}
                  selectedPremium={selectedPremium}
                  lastName={lastName}
                  email={email}
                  phoneNumber={phoneNumber}
                  selectedCountry={selectedCountry}
                  countries={countries}
                  handleCountryChange={this.handleCountryChange}
                  nonTerminalIllness={nonTerminalIllness}
                  validationErrors={validationErrors}
                  creating={creating}
                  getSelectedPremium={this.getSelectedPremium}
                  handleChange={this.handleChange}
                  createInsuranceLead={this.createInsuranceLead}
                  back={this.back}
                />
              )}
              {mode === "lead-created" && (
                <div className="alert alert-success" role="alert">
                  {t("referrals.insurance_calc.thank_you")}
                </div>
              )}
            </div>
          </div>
        </div>
        {mode === "preview" && policies.length > 0 && (
          <div className="action call-to-action" id="call-to-action">
            <button
              type="submit"
              className="btn btn-primary right"
              onClick={this.preview}>
              {t("referrals.insurance_calc.contact_us")}
            </button>
          </div>
        )}
        {mode === "preview" && policies.length == 0 && (
            <div className="alert alert-warning">
            <br></br>
            <div className="mb-4">
            {t("referrals.insurance_calc.age_range")}
              <br></br>
            </div>
          </div>
        )}
        { policies.length == 0 && (
          <div className="summaries">
            <hr></hr>
            <div className="summary">
              <h3>{t("referrals.insurance_calc.total_contribution")} <span className="text-muted">{t("referrals.insurance_calc.click_preview")}</span></h3>
            </div>
            <div className="summary tax-free">
              <h3>
                {t("referrals.insurance_calc.total_tax_free")}{" "}
                <span className="text-muted">{t("referrals.insurance_calc.click_preview")}</span>
              </h3>
            </div>
          </div>
        )}
        {policies.length > 0 && (
            <div className="summaries">
              <hr></hr>
              <div className="summary">
                <h3>{t("referrals.insurance_calc.total_contribution")} {policies[0].contribution_total}</h3>
              </div>
              <div className="summary tax-free">
                <h3>
                  {t("referrals.insurance_calc.total_tax_free")}{" "}
                  <span className="text-success">{policies[0].tax_free_distribution_total}</span>
                </h3>
              </div>
            </div>
          )}

        <hr></hr>
        <br></br>
        <h4>
          {t("referrals.insurance_calc.details_title")} { policies.length > 0 &&  
          ( <span>{t("referrals.insurance_calc.for_ages")} <span className="text-warning">{policies[0].age_range}</span> <i>{t("referrals.insurance_calc.example_open")}</i>) </span>)}
        </h4>
        <div className="results card card-sheet sheet-condensed table-responsive">
          <table className="table table-striped table-hover table-responsive w-100 d-block d-md-table">
            <thead>
              <tr>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_policy_year")}>{t("referrals.insurance_calc.th_policy_year")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_age")}>{t("referrals.insurance_calc.th_age")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_planned_premium")}>{t("referrals.insurance_calc.th_planned_premium")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_annual_income")}>{t("referrals.insurance_calc.th_annual_income")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_accumulated_value")}>{t("referrals.insurance_calc.th_accumulated_value")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_surrender_value")}>{t("referrals.insurance_calc.th_surrender_value")}</th>
                <th scope="col" data-tip={t("referrals.insurance_calc.tip_net_death_benefit")}>{t("referrals.insurance_calc.th_net_death_benefit")}</th>
              </tr>
            </thead>
            <TableBody policies={policies} />
          </table>
          <ReactTooltip data-type="dark" data-background-color="#00669c" />
          {policies.length == 0 && (
            <div className="summaries">
              <br></br>
              <div className="summary mb-4">
                {t("referrals.insurance_calc.enter_info")}
                <br></br>
              </div>
            </div>
          )}
        </div>

        {mode === "preview" && policies.length > 0 && (
        <div className="action call-to-action" id="call-to-action">
          <button
            type="submit"
            className="btn btn-primary right"
            onClick={this.scrollToAction}>
            {t("referrals.insurance_calc.contact_us")}
          </button>
        </div>
        )}

        <div className="notes">
          <div>
            <h4>{t("referrals.insurance_calc.legend")}</h4>
            <ul className="list-group">
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_policy_year")}
              </li>
              <li className="list-group-item">{t("referrals.insurance_calc.leg_age")}</li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_premium")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_income")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_accumulated")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_surrender")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.leg_death")}
              </li>
            </ul>
          </div>
          <div className="recurring">
            <h6>{t("referrals.insurance_calc.recurring")}</h6>
            <ul className="list-group">
              <li className="list-group-item">
                {t("referrals.insurance_calc.rec_year11")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.rec_age65")}
              </li>
              <li className="list-group-item">
                {t("referrals.insurance_calc.rec_age90")}
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default InsuranceCalculator;
